import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

import { BORDER_RADIUS, COLOR, COLOR_FUNCTION, PX_TO_REM } from '@/globalStyles';

export enum FQCARD_VARIANTS {
    fqSmall = 'fqSmall',
    fqAdd = 'fqAdd',
    fqMediumRequestType = 'fqMediumRequestType',
}

const FQCard = styled(Card, { shouldForwardProp: props => props !== 'data-variant' })(props => {
    switch (props['data-variant']) {
        case FQCARD_VARIANTS.fqSmall:
            return {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                border: `1px solid ${COLOR_FUNCTION.border}`,
                borderRadius: BORDER_RADIUS.small,
                width: '16rem',
                height: '4.5rem',
                paddingLeft: '1.9rem',
                paddingRight: '1.9rem',
                boxShadow: 'none',
            };
        case FQCARD_VARIANTS.fqAdd:
            return {
                display: 'flex',
                justifyContent: 'space-center',
                alignItems: 'center',
                border: `1px solid ${COLOR.redWildWatermelon}`,
                borderRadius: BORDER_RADIUS.small,
                width: '16rem',
                height: '4.5rem',
                paddingLeft: '1.9rem',
                paddingRight: '1.9rem',
                boxShadow: 'none',
                cursor: 'pointer',
            };
        case FQCARD_VARIANTS.fqMediumRequestType:
            return {
                position: 'relative',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                border: `1px solid ${COLOR_FUNCTION.border}`,
                borderRadius: BORDER_RADIUS.small,
                width: '7.15rem',
                height: '8rem',
                padding: '1.8rem 0.5rem 1rem 0.5rem',
                boxShadow: 'none',
                cursor: 'pointer',
                transition: `background-color 200ms cubic-bezier(0.4, 0, 0.2, 1)`,
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: '0',
                    left: '0',
                    width: '100%',
                    height: PX_TO_REM[3],
                },
            };
        default:
            return {};
    }
});

export default FQCard;
